import { put, select } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';
import history from '../../utils/history';

const key = 'BUSINESS/CREATE';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchCreateBusiness(client, { payload }) {
  try {
    const location = yield select((state) => state.regionOfLocation);
    const services = payload.categories.map((category) => {
      return {
        _id: category._id,
      };
    });
    const data = {
      nm: payload.businessName,
      dc: '',
      ci: payload.location.location.city._id,
      ri: location.data._id,
      lt: location.data.point[1],
      ln: location.data.point[0],
      sr: services,
      ad: payload.address,
    };
    const response = yield client.post('/business/create', { data: data });
    yield put(actions.loadSuccess(response.result));
    history.push('/');
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
